import { Link } from 'react-router-dom';
import './NotAuthenticated.scss';

export default function NotAuthenticated() {
    return (
        <div id="not-authenticated">
            <div className="centered-container">
                <h1>Not Authenticated</h1>
                <br />
                <p>
                    You are not authenticated. Please <Link to="/login" className="header-link">login</Link> to access this page.
                </p>
            </div>
        </div>
    );
}